class AccordionList {

    /**
     * Constructor
     * @param accordion
     */
    constructor(accordion) {
        /**
         * @type Element
         */
        this.accordion = accordion;
        /**
         * @type {Element }
         */
        this.panel = this.accordion.querySelector('.core');
        /**
         * @type {Element }
         */
        this.button = this.accordion.querySelector('.button-accordion-list');
        /**
         * Init
         */
        this._init();
    }

    /**
     * init
     * @private
     */
    _init() {
        this._addListener();
    }


    /**
     * Add listener
     * @private
     */
    _addListener() {
        this.button.addEventListener('click', () => this.toggle());
    }

    /**
     * Click heading accordion
     */
    toggle() {
        if (this.panel.style.maxHeight) {
            this.panel.style.maxHeight = null;
            Accordion.setPanelHeight(this.accordion.closest('.panel'));
        } else {
            AccordionList.closeAll();
            this.panel.style.maxHeight = this.panel.scrollHeight + "px";
            //Set height parent accordion
            Accordion.setPanelHeight(this.accordion.closest('.panel'));
        }

        this.accordion.classList.toggle("open");
    }

    /**
     * Close all accordion
     */
    static closeAll() {
        const accordions = document.querySelectorAll('.accordion-list');

        for (let i = 0; i < accordions.length; i++) {
            accordions[i].querySelector('.core').style.maxHeight = null;
            accordions[i].classList.remove('open')
        }
    }

}